import { createAction, props } from "@ngrx/store";
import { StaffStatusGridGroup } from "src/app/shared/models/message-hub/staffStatusGridGroupRequest";
import { LobbyStaffGridGridModel } from "../models/lobby-staff-grid.model";
import { ImpersonateUserModel } from '../../shared/models/impersonate-user.model';
import { ImpersonateAssistDetailModel } from "../../shared/models/impersonate-assist-detail.model";
export enum ActionTypes {
    UPDATE_LOBBY_STAFF_STATUS_STAFF_STATUS_GRID = '[LobbyStaffStatus] Update Staff Status Grid',
    UPDATE_LOBBY_LOBBY_GRID = '[LobbyGrid] Update Lobby Grid',
    RECIEVED_LOBBY__GRID_DATA = '[LobbyGrid] Recieved Lobby Grid data',
    UPDATE_LOBBY_STAFF_STATUS_GRID = '[LobbyStaffStatus] Update Staff Status Grid',
    LOAD_LOBBY_STAFF_STATUS_GRID = '[LobbyStaffStatus] Load Lobby Staff Status Grid Data',
    LOBBY_STAFF_STATUS_GROUP_ACTION_COMPLETE = '[LobbyStaffStatus] Join Lobby Staff Status Group ActionComplete',
    LOAD_IMPERSONATE_USERS = '[LobbyStaffStatus] Load Impersonate Users',
    UPDATE_IMPERSONATE_USERS = '[LobbyStaffStatus] Update Impersonate Users',
    PROMPT_IMPERSONATE_POPUP = '[LobbyStaffStatus] Prompt Impersonate Popup',
    LOAD_IMPERSONATE_ASSIST_DETAIL = '[LobbyStaffStatus] Load Impersonate Assist Details',
    UPDATE_IMPERSONATE_ASSIST_DETAIL= '[LobbyStaffStatus] Update Impersonate Assist Details',

}

export const updateLobbyGrid = createAction(
    ActionTypes.UPDATE_LOBBY_LOBBY_GRID,
    props<{ gridData: any }>()
);

export const recievedLobbyGridData = createAction(
    ActionTypes.RECIEVED_LOBBY__GRID_DATA,
    props<{ gridData: any }>()

);

export const updateStaffStatusGrid = createAction(
    ActionTypes.UPDATE_LOBBY_STAFF_STATUS_GRID,
    props<{payload:{gridData: LobbyStaffGridGridModel}}>()
);

export const loadLobbyStaffGridData = createAction(
    ActionTypes.LOAD_LOBBY_STAFF_STATUS_GRID,
    props<{gridParams: StaffStatusGridGroup}>()
)
export const loadImpersonateUsers = createAction(
    ActionTypes.LOAD_IMPERSONATE_USERS,
    props<{locationId: number,showPopUp:boolean}>()
)
export const updateImpersonateUsers = createAction(
    ActionTypes.UPDATE_IMPERSONATE_USERS,
    props<{imperSonateUserDetailinfo: ImpersonateUserModel[],showPopUp:boolean}>()
)
export const promptImpersonatePopup = createAction(
    ActionTypes.PROMPT_IMPERSONATE_POPUP,
    props<{open: boolean}>()
)
export const joinLobbyStaffGridGroupActionComplete = createAction(
    ActionTypes.LOBBY_STAFF_STATUS_GROUP_ACTION_COMPLETE
);
export const loadImpersonateAssistDetails = createAction(
    ActionTypes.LOAD_IMPERSONATE_ASSIST_DETAIL
   
)
export const updateImpersonatAssistDetails = createAction(
    ActionTypes.UPDATE_IMPERSONATE_ASSIST_DETAIL,
    props<{imperSonateAssistDetailinfo: ImpersonateAssistDetailModel}>()
)
